import React, { Component }          from 'react';

import axios                         from 'axios';
import { IndeterminateProgress }     from '../common/IndeterminateProgress';
import passwordValidator             from 'password-validator';

import "./SetPassword.scss";

class SetPassword extends Component {

  constructor(props) {
    super(props);

    this.state            = {
      password: "",
      confirmPassword: "",
      errorText: "",
      showErrorText: false,
      isSubmitting: false,
      showDialog: false,
    }
    this.schema = new passwordValidator();
    this.schema
      .is().min(8)
      .is().max(30)
      .has().symbols()
      .has().uppercase()
      .has().lowercase()
      .has().not().spaces()
      .is().not().oneOf(['Passw0rd', 'Password123', 'password', 'Password']); 
  }

  componentDidMount() {
  }

  passwordValid() {
    return this.schema.validate(this.state.password);
  }

  onFieldChange(name, event) {
    this.setState({[name]: event.target.value});
  }

  onSubmitClicked() {
    if (!this.state.password || !this.state.confirmPassword) {
      this.setState({showErrorText: true, errorText: "Please complete all fields"});
      this.animateLoginButton()
    } else if (this.state.password !== this.state.confirmPassword) {
      this.setState({showErrorText: true, errorText: "Password and confirm password fields must match"});
      this.animateLoginButton()
    } else if (!this.passwordValid()) {
      this.setState({showErrorText: true, errorText: "Password must bet at least 8 characters long (max 30) and include upper and lowercase characters, as well as symbols."});
      this.animateLoginButton()
    } else {
      const urlParams1 = new URLSearchParams(window.location.hash.replace("#/set-password", ""))
      const code = urlParams1.get('code');

      this.setState({isSubmitting: true})
      axios.post(`/api/set-password`, {
        password: this.state.password,
        code: code,
      }).then(() => {
        this.setState({showDialog: true, isSubmitting: false});
        setTimeout(() => {
          this.setState({showDialog: false});
          window.location.href = "/#/admin"
        }, 2000);
      }).catch(e => {
        this.setState({showErrorText: true, isSubmitting: false, errorText: 'Invalid password reset request code. Please request another.'})
      })
    }
  }

  animateLoginButton() {
    this.setState({animateLoginButton: true});
    setTimeout(() => this.setState({animateLoginButton: false}), 500);
  }

  render() {
    return (
      <div className={`set-password__container`}>
        <div className={`set-password-content ${this.state.isSubmitting ? 'blur' : ''}`}>
          <div className="page-title">SET PASSWORD</div>
          <div className="field">
            <div className="title">PASSWORD</div>
            <input type="password" onChange={(event) => this.onFieldChange('password', event)} value={this.state.password}/>
          </div>
          <div className="field">
            <div className="title">CONFIRM PASSWORD</div>
            <input type="password" onChange={(event) => this.onFieldChange('confirmPassword', event)} value={this.state.confirmPassword}/>
          </div>
          <div className="field">
            <div onClick={this.onSubmitClicked.bind(this)} className={`action-button ${this.state.animateLoginButton ? 'incorrect-animate' : ''}`}>
              SUBMIT
            </div>
            <div className={`error-text ${this.state.showErrorText ? 'show' : ''}`}>{this.state.errorText}</div>
          </div>
        </div>
        <IndeterminateProgress show={this.state.isSubmitting} />
        <div className={`dialog-container ${this.state.showDialog ? 'show' : ''}`}>
          <div className="dialog-content">
            Password successfully set
          </div>
        </div>
      </div>
    );
  }
}

export default SetPassword;